import PropTypes from 'prop-types';

const formType = PropTypes.shape({
    formType: PropTypes.string.isRequired,
    recruitingTypeId: PropTypes.number,
    class: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    footer: PropTypes.string.isRequired,
    success: PropTypes.string.isRequired,
    getPrimaryIndustry: PropTypes.bool,
    useFirstAndLastName: PropTypes.bool,
    hideHowDidYouHear: PropTypes.bool,
    primaryIndustry: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string.isRequired,
            text: PropTypes.string.isRequired,
        }).isRequired
    ),
    emailTo: PropTypes.arrayOf(
        PropTypes.shape({
            type: PropTypes.string.isRequired,
            emailAddress: PropTypes.string.isRequired,
        }).isRequired
    ),
}).isRequired;

export default formType;
